import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Liability, Asset } from '@funnels/types';

export function findLiabilityIndex(formValues: any, assetIndex: number) {
  const liabilities = get(formValues, FIELD_PATHS.LIABILITIES(), []) as Liability[];

  return liabilities.findIndex((__, i) => {
    const liabilityAssetId = get(formValues, FIELD_PATHS.LIABILITY_ASSET_ID(i));
    const liabilityAssetClientId = get(formValues, FIELD_PATHS.LIABILITY_ASSET_CLIENT_ID(i));
    const assetId = get(formValues, FIELD_PATHS.ASSET_ID(assetIndex));
    const assetClientId = get(formValues, FIELD_PATHS.ASSET_CLIENT_ID(assetIndex));

    if (!assetId) {
      return liabilityAssetClientId.includes(assetClientId);
    } else if (assetId) {
      return liabilityAssetId.includes(assetId);
    }

    return false;
  });
}

export function findAssetIndex(formValues: any, liabilityIndex: number) {
  const assets = get(formValues, FIELD_PATHS.ASSETS(), []) as Asset[];
  const liabilityAssetId = get(formValues, `${FIELD_PATHS.LIABILITY_ASSET_ID(liabilityIndex)}[0]`);
  const liabilityAssetClientId = get(formValues, `${FIELD_PATHS.LIABILITY_ASSET_CLIENT_ID(liabilityIndex)}[0]`);

  if (!liabilityAssetId && !liabilityAssetClientId) {
    return -1;
  }

  return assets.findIndex((__, i) => {
    const assetId = get(formValues, FIELD_PATHS.ASSET_ID(i));
    const assetClientId = get(formValues, FIELD_PATHS.ASSET_CLIENT_ID(i));

    if (!assetId) {
      return liabilityAssetClientId.includes(assetClientId);
    } else if (assetId) {
      return liabilityAssetId.includes(assetId);
    }

    return false;
  });
}
